module.exports = __webpack_public_path__ + "static/img/img_gyc_a.a9b54ad8.png";